import React from "react";
import { Grid, Dropdown, Button, Icon, Checkbox, Form } from "semantic-ui-react";
import Input from "@Components/Input";
import InputFilter from "@Components/InputFilter";
import Text from "@Components/Text";
import TextareaAutosize from "react-textarea-autosize";
import styles from "./styles.module.css";
import { isEmpty, isArray, includes, find } from "lodash";
import PropTypes from "prop-types";

const FilterUI = ({
	// Errors
	errors = {},
	// Report selection
	options = [],
	selectedFilterTemp,
	onChangeSelection,
	// Dates
	startDate,
	endDate,
	handleInput,
	getMaxDate,
	// Ordering
	tempOrderBy,
	handleOrderByChange,
	getOrderByOptions,
	orderDirectionOptions,
	tempOrderDirection,
	setTempOrderDirection,
	// Contacts
	contacts,
	onContactsSelect,
	onContactsRemove,
	contactOption,
	// Users/Agents
	agents,
	setAgents,
	agentsData,
	renderLabelPlatforms,
	// Tags
	tagsSelected,
	handleInputDropdown,
	tagsData,
	handleTipyfication,
	// Note/Text
	note,
	setNote,
	// Channels
	channelAll,
	checkAll,
	channelFilters,
	channelfiltersData,
	renderLabelChannels,
	// Groups
	groupsData,
	groupsAll,
	groupsfilters,
	onChangeDropdown,
	renderLabelDepartments,
	// Actions
	cleanModal,
	cleaned,
	getFieldsetClass,
	// Actions history
	actionsHistory = [],
	setActionsHistory = () => {},
	// Categories
	categoriesSelected = [],
	setCategoriesSelected = () => {},
	categoriesData = [],
	isGeneralReport = false,
}) => {
	const actionOptions = [
		{ key: "Cierre", text: "Cierre", value: "Cierre" },
		{ key: "Tomar", text: "Tomar", value: "Tomar" },
		{ key: "Transferir", text: "Transferir", value: "Transferir" },
		{ key: "Bloquear", text: "Bloquear", value: "Bloquear" },
		{ key: "Liberar", text: "Liberar", value: "Liberar" },
	];

	const handleCategorySelection = (e, { value }) => {
		setCategoriesSelected(value);
		const promoCategory = find(categoriesData, (c) => {
			return c.text.toLowerCase() === "promo";
		});
		if (promoCategory && includes(value, promoCategory.value)) {
			const promoTag = find(isArray(tagsData) ? tagsData : [], (t) => {
				return t.text.toLowerCase() === "promo";
			});
			if (promoTag && (!tagsSelected || !includes(tagsSelected, promoTag.value))) {
				const newTags = [...(tagsSelected || []), promoTag.value];
				if (handleTipyfication) {
					handleTipyfication("tagsSelected", newTags);
				} else if (handleInputDropdown) {
					handleInputDropdown(e, { name: "tagsSelected", value: newTags });
				}
			}
		}
	};

	const showSecondFieldset =
		!isGeneralReport ||
		selectedFilterTemp === "Etiquetas" ||
		selectedFilterTemp === "Etiquetas Grupo" ||
		selectedFilterTemp === "Etiquetas-Notas";

	return (
		<Grid className={styles.grid}>
			<div className={styles.containerFirst}>
				<fieldset className={styles.fieldset}>
					<legend className={styles.legendWithButton}>
						<span className={styles.legend}>Filtrado</span>
						<div className={styles.clearButtonContainer}>
							<Button icon size="mini" onClick={cleanModal} className={styles.clearButtonInline}>
								<Icon name="trash alternate outline" />
								Limpiar Todo
							</Button>
							{cleaned && <span className={styles.tooltipAbove}>¡Filtros limpiados!</span>}
						</div>
					</legend>

					<div className={styles.dateContent}>
						<div className={styles.dateFieldDate}>
							{!isEmpty(options) && (
								<div className={styles.userDropdownBlock2}>
									<span className={styles.lookUpLabel}>Tipo de Reporte:</span>
									<Dropdown
										className={styles.filterDropdown}
										placeholder="Selecciona un filtro"
										selection
										search
										options={options}
										value={selectedFilterTemp}
										onChange={onChangeSelection}
									/>
								</div>
							)}
							<div className={styles.flexContainer}>
								<Input
									type={selectedFilterTemp === "Año/Mes" ? "month" : "date"}
									label={<span>Desde:{selectedFilterTemp === "Año/Mes" && <span style={{ color: "red" }}> *</span>}</span>}
									icon="calendar minus"
									iconPosition="left"
									placeholder="Inicio"
									fluid
									size="mini"
									name="startDate"
									value={startDate}
									max={getMaxDate()}
									onChange={handleInput}
									className={styles.dateInput}
								/>
								<Input
									type={selectedFilterTemp === "Año/Mes" ? "month" : "date"}
									label={<span>Hasta:{selectedFilterTemp === "Año/Mes" && <span style={{ color: "red" }}> *</span>}</span>}
									icon="calendar plus"
									iconPosition="left"
									placeholder="Final"
									fluid
									size="mini"
									name="endDate"
									value={endDate}
									min={startDate}
									max={getMaxDate()}
									onChange={handleInput}
									className={styles.dateInput}
								/>
							</div>
						</div>
					</div>
					{["No Trabajadas", "Etiquetas", "Etiquetas Grupo", "Año/Mes", "Acciones"].includes(selectedFilterTemp) && (
						<div className={styles.containerOptions}>
							<div className={styles.containerOrder}>
								<Text className={styles.textTypificacion}>Ordenar por:</Text>
								<Dropdown
									fluid
									search
									placeholder="Seleccionar"
									options={getOrderByOptions()}
									value={tempOrderBy}
									onChange={(e, { value }) => {
										return handleOrderByChange(value);
									}}
									selection
									clearable
								/>
							</div>
							<div className={styles.containerOrder}>
								<Text className={styles.textTypificacionSpecial}>&nbsp;</Text>
								<Dropdown
									fluid
									search
									placeholder="Seleccionar"
									options={orderDirectionOptions}
									value={tempOrderDirection}
									onChange={(e, { value }) => {
										setTempOrderDirection(value);
									}}
									selection
									clearable
									error={!!errors.selected && tempOrderBy && !tempOrderDirection}
								/>
							</div>
						</div>
					)}
					{selectedFilterTemp === "Acciones" && (
						<div className={styles.containerOptions}>
							<div className={styles.userDropdownBlock}>
								<Text className={styles.textTypificacion}>Acciones:</Text>
								<Dropdown
									fluid
									multiple
									selection
									search
									placeholder="Seleccionar Acciones"
									options={actionOptions}
									value={actionsHistory}
									onChange={(e, { value }) => {
										return setActionsHistory(value);
									}}
								/>
							</div>
						</div>
					)}
				</fieldset>
				<fieldset className={styles.fieldset}>
					<legend className={styles.legend}>Otros</legend>
					<div className={styles.contactContainer}>
						<div className={styles.lookUpLabel}>Contacto:</div>
						<InputFilter
							contactData={contacts}
							selectedContact={onContactsSelect}
							onEmpty={onContactsRemove}
							url="contacts"
							defaultField="all"
							forceInputValue="name"
							selectTitle="Buscar Contactos"
							tableColumns={contactOption}
						/>
					</div>
					<div className={styles.userContainerTags}>
						<div
							className={`${styles.userDropdownBlock} ${styles.typification} ${
								selectedFilterTemp === "Resumidas" ? styles.resumidasCompact : ""
							} ${selectedFilterTemp === "Hora/Usuarios" ? styles.resumidasCompact : ""} ${
								selectedFilterTemp === "Hora/Grupos" ? styles.resumidasCompact : ""
							} ${selectedFilterTemp === "Por Días" ? styles.resumidasCompact : ""} ${
								selectedFilterTemp === "Por Horas" ? styles.resumidasCompact : ""
							}`}>
							<Text className={styles.lookUpLabel}>Usuarios:</Text>
							<Dropdown
								fluid
								onChange={(e, { value }) => {
									return setAgents(value);
								}}
								value={agents}
								renderLabel={renderLabelPlatforms}
								multiple
								selection
								search
								clearable
								options={agentsData}
							/>
						</div>
						{selectedFilterTemp !== "Resumidas" &&
							selectedFilterTemp !== "Hora/Usuarios" &&
							selectedFilterTemp !== "Hora/Grupos" &&
							selectedFilterTemp !== "Por Días" &&
							selectedFilterTemp !== "Por Horas" &&
							!isGeneralReport && (
								<>
									<div className={`${styles.userDropdownBlock} ${styles.typification}`}>
										<Text className={styles.lookUpLabel}>Por Categoría:</Text>
										<Dropdown
											fluid
											name="categoriesSelected"
											value={categoriesSelected}
											onChange={handleCategorySelection}
											options={categoriesData}
											placeholder="Seleccionar"
											size="mini"
											search
											multiple
											selection
											clearable
											renderLabel={renderLabelPlatforms}
											disabled={selectedFilterTemp === "Acciones"}
										/>
									</div>
									<div className={`${styles.userDropdownBlock} ${styles.typification}`}>
										<Text className={styles.lookUpLabel}>Por Nombre:</Text>
										<Dropdown
											fluid
											name="tagsSelected"
											value={tagsSelected}
											onChange={handleInputDropdown}
											options={
												!isEmpty(categoriesSelected)
													? (isArray(tagsData) ? tagsData : []).filter((tag) => {
															return includes(categoriesSelected, tag.categoryId);
													  })
													: tagsData
											}
											handleSelection={handleTipyfication}
											placeholder="Seleccionar"
											size="mini"
											search
											multiple
											selection
											clearable
											selected
											renderLabel={renderLabelPlatforms}
											disabled={selectedFilterTemp === "Acciones"}
										/>
									</div>
								</>
							)}
						{isGeneralReport &&
							(selectedFilterTemp === "Etiquetas" ||
								selectedFilterTemp === "Etiquetas Grupo" ||
								selectedFilterTemp === "Etiquetas-Notas") && (
								<div className={`${styles.userDropdownBlock} ${styles.typification}`}>
									<div className={`${styles.contDiv} ${styles.marginBottom05rem} ${styles.justifySpaceBetween}`}>
										<Text className={styles.lookUpLabel}>Grupos:</Text>
										<div className={styles.flexAlignCent}>
											<Checkbox
												name="groupsAll"
												className={styles.checkBox}
												checked={groupsAll}
												onChange={() => {
													return checkAll("groupsfilters");
												}}
												disabled={selectedFilterTemp === "Acciones"}
											/>
											<Text className={`${styles.sectionTitleText} ${styles.marginLeft05rem}`}>Todos</Text>
										</div>
									</div>
									<Dropdown
										fluid
										onChange={(e, { value }) => {
											return onChangeDropdown(value, "groupsfilters");
										}}
										placeholder="Seleccionar Grupos"
										multiple
										clearable
										search
										selection
										value={groupsfilters}
										options={groupsData}
										renderLabel={renderLabelDepartments}
										disabled={selectedFilterTemp === "Acciones"}
									/>
								</div>
							)}
					</div>
					{selectedFilterTemp !== "Hora/Usuarios" &&
						selectedFilterTemp !== "Etiquetas" &&
						selectedFilterTemp !== "Etiquetas Grupo" &&
						selectedFilterTemp !== "Etiquetas-Notas" &&
						selectedFilterTemp !== "Acciones" &&
						selectedFilterTemp !== "No Trabajadas" && (
							<Form className={styles.typification}>
								<Text className={styles.textTypificacion}>Texto:</Text>
								<div style={{ position: "relative" }}>
									<TextareaAutosize
										value={note}
										name="messageArea"
										onChange={(e) => {
											return setNote(e.target.value);
										}}
										className={styles.inputGroupB}
										rows={1}
									/>
									{note && (
										<Icon
											name="x"
											className={styles.iconCloseInside}
											onClick={() => {
												setNote("");
											}}
										/>
									)}
								</div>
							</Form>
						)}
				</fieldset>
			</div>
			<div className={styles.filtersContainer}>
				<fieldset
					className={`${styles.fieldsetChannel} ${!isEmpty(errors.selected) ? styles.error : ""} ${getFieldsetClass(
						channelFilters,
						channelfiltersData
					)} ${!showSecondFieldset ? styles.singleFieldsetWidth : ""}`}>
					<legend className={styles.legend}>Canales</legend>
					<div className={styles.section}>
						<div className={styles.contDiv}>
							<Checkbox
								className={styles.checkBox}
								name="channelAll"
								checked={channelAll}
								onChange={() => {
									return checkAll("channelFilters");
								}}
							/>
							{!isEmpty(errors.channelfilters) && (
								<Text className={styles.ErrorChannel} color="red">
									{errors.channelfilters}
								</Text>
							)}
							<Text className={styles.sectionTitleText}>Todos</Text>
						</div>

						<div className={styles.sectionContent}>
							<Dropdown
								fluid
								onChange={(e, { value }) => {
									return onChangeDropdown(value, "channelFilters");
								}}
								value={channelFilters}
								placeholder="Seleccionar"
								multiple
								clearable
								search
								selection
								options={channelfiltersData}
								renderLabel={renderLabelChannels}
								upward
							/>
						</div>
					</div>
				</fieldset>

				{(!isGeneralReport ||
					selectedFilterTemp === "Etiquetas" ||
					selectedFilterTemp === "Etiquetas Grupo" ||
					selectedFilterTemp === "Etiquetas-Notas") && (
					<fieldset
						className={`${styles.fieldsetGroup} ${!isEmpty(errors.selected) ? styles.error : ""} ${getFieldsetClass(
							isGeneralReport ? tagsSelected : groupsfilters,
							isGeneralReport ? tagsData : groupsData
						)}`}>
						<legend className={styles.legend}>{isGeneralReport ? "Etiquetas" : "Grupos"}</legend>
						{!isGeneralReport ? (
							<>
								<div className={styles.contDiv}>
									<Checkbox
										name="groupsAll"
										className={styles.checkBox}
										checked={groupsAll}
										onChange={() => {
											return checkAll("groupsfilters");
										}}
										disabled={selectedFilterTemp === "Acciones"}
									/>
									<Text className={styles.sectionTitleText}>Todos</Text>
								</div>

								<div className={styles.sectionContent}>
									<Dropdown
										fluid
										onChange={(e, { value }) => {
											return onChangeDropdown(value, "groupsfilters");
										}}
										placeholder="Seleccionar"
										multiple
										clearable
										search
										selection
										value={groupsfilters}
										options={groupsData}
										renderLabel={renderLabelDepartments}
										upward
										disabled={selectedFilterTemp === "Acciones"}
									/>
								</div>
							</>
						) : (
							<div className={styles.sectionContent}>
								{selectedFilterTemp !== "Resumidas" &&
									selectedFilterTemp !== "Hora/Usuarios" &&
									selectedFilterTemp !== "Hora/Grupos" &&
									selectedFilterTemp !== "Por Días" &&
									selectedFilterTemp !== "Por Horas" && (
										<>
											<div className={`${styles.userDropdownBlock} ${styles.typification}`}>
												<Text className={styles.lookUpLabel}>Por Categoría:</Text>
												<Dropdown
													fluid
													name="categoriesSelected"
													value={categoriesSelected}
													onChange={handleCategorySelection}
													options={categoriesData}
													placeholder="Seleccionar"
													size="mini"
													search
													multiple
													selection
													clearable
													renderLabel={renderLabelPlatforms}
													disabled={selectedFilterTemp === "Acciones"}
												/>
											</div>
											<div className={`${styles.userDropdownBlock} ${styles.typification} ${styles.marginTop1rem}`}>
												<Text className={styles.lookUpLabel}>Por Etiqueta:</Text>
												<Dropdown
													fluid
													name="tagsSelected"
													value={tagsSelected}
													onChange={handleInputDropdown}
													options={
														!isEmpty(categoriesSelected)
															? (isArray(tagsData) ? tagsData : []).filter((tag) => {
																	return includes(categoriesSelected, tag.categoryId);
															  })
															: tagsData
													}
													handleSelection={handleTipyfication}
													placeholder="Seleccionar"
													size="mini"
													search
													multiple
													selection
													clearable
													selected
													renderLabel={renderLabelPlatforms}
													disabled={selectedFilterTemp === "Acciones"}
												/>
											</div>
										</>
									)}
							</div>
						)}
					</fieldset>
				)}
			</div>
		</Grid>
	);
};

FilterUI.propTypes = {
	errors: PropTypes.object,
	options: PropTypes.array,
	selectedFilterTemp: PropTypes.string,
	onChangeSelection: PropTypes.func,
	startDate: PropTypes.string,
	endDate: PropTypes.string,
	handleInput: PropTypes.func,
	getMaxDate: PropTypes.func,
	tempOrderBy: PropTypes.string,
	handleOrderByChange: PropTypes.func,
	getOrderByOptions: PropTypes.func,
	orderDirectionOptions: PropTypes.array,
	tempOrderDirection: PropTypes.string,
	setTempOrderDirection: PropTypes.func,
	contacts: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
	onContactsSelect: PropTypes.func,
	onContactsRemove: PropTypes.func,
	contactOption: PropTypes.array,
	agents: PropTypes.array,
	setAgents: PropTypes.func,
	agentsData: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
	renderLabelPlatforms: PropTypes.func,
	tagsSelected: PropTypes.array,
	handleInputDropdown: PropTypes.func,
	tagsData: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
	handleTipyfication: PropTypes.func,
	note: PropTypes.string,
	setNote: PropTypes.func,
	channelAll: PropTypes.bool,
	checkAll: PropTypes.func,
	channelFilters: PropTypes.array,
	channelfiltersData: PropTypes.array,
	renderLabelChannels: PropTypes.func,
	groupsData: PropTypes.array,
	groupsAll: PropTypes.bool,
	groupsfilters: PropTypes.array,
	onChangeDropdown: PropTypes.func,
	renderLabelDepartments: PropTypes.func,
	cleanModal: PropTypes.func,
	cleaned: PropTypes.bool,
	getFieldsetClass: PropTypes.func,
	actionsHistory: PropTypes.array,
	setActionsHistory: PropTypes.func,
	categoriesSelected: PropTypes.array,
	setCategoriesSelected: PropTypes.func,
	categoriesData: PropTypes.array,
	isGeneralReport: PropTypes.bool,
};

export default FilterUI;
